module.exports = __webpack_public_path__ + "static/media/es.caa6452f.svg";